<div
  class="relative flex min-h-dvh flex-col items-center justify-center bg-[#0B0E14] px-4 py-10 font-sans antialiased"
>
  <div class="absolute end-4 top-4">
    <app-language-switcher />
  </div>

  <div class="mb-8 flex flex-col items-center text-center">
    <div
      class="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-linear-to-r from-[#3B82F6] to-[#8B5CF6] shadow-lg shadow-[#3B82F6]/20"
      aria-hidden="true"
    >
      <svg
        class="h-7 w-7 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="1.75"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 3.5 5 7v5c0 5.25 3.5 9 7 10 3.5-1 7-4.75 7-10V7l-7-3.5Z"
        />
      </svg>
    </div>
    <h1 class="text-xl font-bold tracking-tight text-white">{{ 'common.app.name' | t }}</h1>
    <p class="mt-1 text-sm text-[#94A3B8]">{{ 'common.app.product' | t }}</p>
  </div>

  <div
    class="w-full max-w-md rounded-2xl border border-white/10 bg-[#151B26] px-8 py-8 shadow-xl shadow-black/40"
  >
    <div class="mb-6">
      <h2 class="text-lg font-semibold text-white">{{ 'auth.welcome' | t }}</h2>
      <p class="mt-1 text-sm text-[#94A3B8]">{{ 'auth.subtitle' | t }}</p>
    </div>

    @if (configError()) {
      <div
        class="mb-4 rounded-xl border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-200"
        role="alert"
      >
        <p>{{ configError() }}</p>
        <button
          type="button"
          (click)="retryConfig()"
          class="mt-2 text-xs font-medium text-red-100 underline hover:no-underline"
        >
          {{ 'common.retry' | t }}
        </button>
      </div>
    }

    <form (submit)="onSubmit($event)" class="flex flex-col gap-5">
      <div>
        <label for="auth-username" class="mb-1.5 block text-sm font-medium text-white">{{
          'auth.usernameLabel' | t
        }}</label>
        <div
          class="flex items-center gap-2 rounded-xl border border-[#334155] bg-[#0B0E14] px-3 transition-colors focus-within:border-[#64748B] focus-within:ring-1 focus-within:ring-[#3B82F6]/40"
        >
          <svg
            class="h-5 w-5 shrink-0 text-[#64748B]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M21.75 6.75v10.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5V6.75m19.5 0A1.5 1.5 0 0 0 20.25 5.25h-15a1.5 1.5 0 0 0-1.5 1.5m19.5 0v.243a1.5 1.5 0 0 1-.66 1.245l-7.49 4.987a1.5 1.5 0 0 1-1.66 0l-7.49-4.987a1.5 1.5 0 0 1-.66-1.245V6.75"
            />
          </svg>
          <input
            id="auth-username"
            name="userName"
            type="text"
            autocomplete="username"
            [(ngModel)]="userName"
            [placeholder]="'auth.usernamePlaceholder' | t"
            [disabled]="configLoading() || !!configError()"
            class="h-12 w-full min-w-0 bg-transparent text-sm text-white outline-none placeholder:text-[#64748B] disabled:cursor-not-allowed disabled:opacity-50"
          />
        </div>
      </div>

      <div>
        <label for="auth-password" class="mb-1.5 block text-sm font-medium text-white">{{
          'auth.passwordLabel' | t
        }}</label>
        <div
          class="flex items-center gap-2 rounded-xl border border-[#334155] bg-[#0B0E14] px-3 transition-colors focus-within:border-[#64748B] focus-within:ring-1 focus-within:ring-[#3B82F6]/40"
        >
          <svg
            class="h-5 w-5 shrink-0 text-[#64748B]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M16.5 10.5V8a4.5 4.5 0 1 0-9 0v2.5M6 12.75h12v7.5H6v-7.5Z"
            />
          </svg>
          <input
            id="auth-password"
            name="password"
            [type]="passwordVisible() ? 'text' : 'password'"
            autocomplete="current-password"
            [(ngModel)]="password"
            [placeholder]="'auth.passwordPlaceholder' | t"
            [disabled]="configLoading() || !!configError()"
            class="h-12 w-full min-w-0 flex-1 bg-transparent text-sm text-white outline-none placeholder:text-[#64748B] disabled:cursor-not-allowed disabled:opacity-50"
          />
          <button
            type="button"
            (click)="togglePasswordVisible()"
            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-[#64748B] transition-colors hover:bg-white/5 hover:text-[#94A3B8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3B82F6]"
            [attr.aria-label]="
              passwordVisible() ? ('auth.hidePassword' | t) : ('auth.showPassword' | t)
            "
            [attr.aria-pressed]="passwordVisible()"
          >
            @if (passwordVisible()) {
              <svg
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                />
              </svg>
            } @else {
              <svg
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M2.25 12s3.75-6.75 9.75-6.75S21.75 12 21.75 12s-3.75 6.75-9.75 6.75S2.25 12 2.25 12Z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                />
              </svg>
            }
          </button>
        </div>
      </div>

      @if (formError()) {
        <p class="text-sm text-red-400" role="alert">{{ formError() }}</p>
      }

      <button
        type="submit"
        [disabled]="configLoading() || !!configError() || submitting()"
        class="mt-1 flex h-12 w-full items-center justify-center rounded-xl bg-linear-to-r from-[#3B82F6] to-[#8B5CF6] text-sm font-semibold text-white shadow-lg shadow-[#3B82F6]/25 transition hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#8B5CF6] focus-visible:ring-offset-2 focus-visible:ring-offset-[#151B26] disabled:cursor-not-allowed disabled:opacity-60"
      >
        @if (submitting()) {
          {{ 'auth.submitting' | t }}
        } @else if (configLoading()) {
          {{ 'common.loading' | t }}
        } @else {
          {{ 'auth.submit' | t }}
        }
      </button>
    </form>
  </div>
</div>
